module.exports = __webpack_public_path__ + "static/media/user.9f2deeb5.svg";